import Component, { mixins } from "vue-class-component";

import { AxiosError, AxiosResponse } from "axios";
import store, { STORE_ACTIONS } from "@/store";
import { LOCAL_STORAGE_KEY_TOKEN } from "../global/user-session/UserSession.store";

export interface IAuthenticateRequestPayload {
  username: string;
  password: string;
}

export interface IAuthenticateRequestResponse {
  token: string;
  'jwt-etudiant': string;
}

@Component
export default class AuthenticationService extends mixins() {
  protected service_authenticationService_authenticate(requestPayload: IAuthenticateRequestPayload): Promise<IAuthenticateRequestResponse> {
    return new Promise((resolve: any, reject: any): void => {
      this.$axios.post('/api/gateway/inscriptions-lieu-examen/authentification', requestPayload)
        .then((response: AxiosResponse) => {
          const data: IAuthenticateRequestResponse = response.data.data

          store.dispatch(STORE_ACTIONS.SESSION_STORE_LOGIN, data["jwt-etudiant"])
          localStorage.setItem(LOCAL_STORAGE_KEY_TOKEN, data['token'])

          resolve(data)
        }).catch((error: AxiosError) => reject(error))
    })
  }
}